export default {
  title: "Uups, etwas ist schief gelaufen",
  description:
    "Bitte starte die Seite neu oder klicke unten auf den Button “Zurück zum Menü” button",
  custom_button: {
    return: "Zurück zum Menü",
  },
};
